// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2gFm8","error":"Textarea_error__PpMmn","readonly":"Textarea_readonly__Zj6XL","disabled":"Textarea_disabled__15m7W"};